import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.number.constructor.js";
import { isNumber } from '@finect/front-utils/isNumber';
export var getViewType = function getViewType(field) {
  var format = field.format;
  if (['date'].includes(field.type)) {
    return 'date';
  }
  if (['enum', 'range'].includes(field.type)) {
    return 'radio';
  }
  if (['array'].includes(field.type)) {
    if (field.format) {
      return 'checkbox';
    }
    return 'array<string>';
  }
  if (['number'].includes(field.type)) {
    return format ? 'radio' : 'number';
  }
  if (['string'].includes(field.type)) {
    return 'string';
  }
  if (['boolean'].includes(field.type)) {
    return 'boolean';
  }
  return 'string';
};
export var getEmptyInitialValue = function getEmptyInitialValue(field) {
  if (['date'].includes(field.type)) {
    return null;
  }
  if (['enum'].includes(field.type)) {
    return null;
  }
  if (['array'].includes(field.type)) {
    return [];
  }
  if (['number'].includes(field.type)) {
    return '';
  }
  if (['string'].includes(field.type)) {
    return '';
  }
  if (['boolean'].includes(field.type)) {
    return false;
  }
};
export var getInitialValue = function getInitialValue(field, value) {
  if (value !== null) {
    return value;
  }
  return getEmptyInitialValue(field);
};
function dateIsValid(date) {
  return date instanceof Date && !isNaN(date);
}
export var isUnlock = function isUnlock(field, value) {
  if (['date'].includes(field.type)) {
    return dateIsValid(new Date(value));
  }
  if (['array'].includes(field.type)) {
    if (field.format) {
      return field.format.map(function (item) {
        return item.value;
      }).some(function (item) {
        return value.includes(item);
      });
    }
    return true;
  }
  if (['enum', 'range'].includes(field.type)) {
    return field.format.map(function (item) {
      return item.value;
    }).includes(value);
  }
  if (['number'].includes(field.type)) {
    if (field.format) {
      return field.format.map(function (item) {
        return Number(item.value);
      }).includes(value);
    }
    return isNumber(value);
  }
  if (['string'].includes(field.type)) {
    return value.length;
  }
  if (['boolean'].includes(field.type)) {
    return [false, true].includes(value);
  }
};